const UsersWm = ({
  color = '#E9BF6E',
  width = 24,
  height = 24,
}: {
  color?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_360_22327)">
        <path
          d="M19.25 21.2499H23.25V16.9269C23.2499 16.7271 23.1899 16.5319 23.0778 16.3665C22.9657 16.2011 22.8066 16.0731 22.621 15.9989L18.879 14.4989C18.6938 14.4249 18.5349 14.2972 18.4228 14.1322C18.3107 13.9672 18.2505 13.7724 18.25 13.5729V12.6949C18.8565 12.3469 19.3607 11.8452 19.7117 11.2405C20.0628 10.6357 20.2485 9.94919 20.25 9.24992V7.24992C20.2502 6.5477 20.0654 5.85781 19.7144 5.24961C19.3634 4.64141 18.8585 4.13633 18.2504 3.78515C17.6423 3.43397 16.9524 3.24906 16.2502 3.24902C15.548 3.24898 14.8581 3.43381 14.25 3.78492"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
        <path
          d="M14.621 16.999L10.879 15.499C10.6938 15.425 10.5349 15.2973 10.4228 15.1323C10.3107 14.9672 10.2505 14.7725 10.25 14.573V14.122C13.52 13.685 14.25 12.25 14.25 12.25C14.25 12.25 12.25 10.25 12.25 8.25C12.25 7.18913 11.8286 6.17172 11.0784 5.42157C10.3283 4.67143 9.31087 4.25 8.25 4.25C7.18913 4.25 6.17172 4.67143 5.42157 5.42157C4.67143 6.17172 4.25 7.18913 4.25 8.25C4.25 10.25 2.25 12.25 2.25 12.25C2.25 12.25 2.98 13.685 6.25 14.122V14.573C6.24987 14.7728 6.18989 14.968 6.07777 15.1334C5.96566 15.2988 5.80656 15.4269 5.621 15.501L1.879 17.001C1.69375 17.075 1.53488 17.2027 1.42279 17.3677C1.3107 17.5328 1.25053 17.7275 1.25 17.927V21.25H15.25V17.927C15.2499 17.7272 15.1899 17.532 15.0778 17.3666C14.9657 17.2012 14.8066 17.0731 14.621 16.999Z"
          stroke={color}
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="square"
        />
      </g>
      <defs>
        <clipPath id="clip0_360_22327">
          <rect width={width} height={height} fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UsersWm;
